import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {GiIronCross} from 'react-icons/gi'
import {NullAsDefault} from 'views/Shared'
import {renderIf, renderIfElse} from '../../../Shared'
import {PiArrowFatLineRightFill} from "react-icons/pi";
import {Popover} from "antd";
import {GoDotFill} from "react-icons/go";
import {renderDayOfWeek} from "../../../AppLocals/Church/functions/renderDayOfWeek";
import {formatDate, parseDayjs} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";

// from_date/to_date chỉ có ý nghĩa NGÀY (khoảng thời gian áp dụng lịch lặp), không phải mốc giờ cụ thể —
// luôn format DD/MM/YYYY thuần, không dùng renderFromToTime (dùng cho mốc có giờ, gây hiện "07:00" ảo
// do lệch múi giờ khi ngày lưu ở UTC 00:00 hiển thị local UTC+7).
const formatDateRange = (from_date, to_date) => {
    const from = formatDate(from_date, 'DD/MM/YYYY')
    const to = formatDate(to_date, 'DD/MM/YYYY')
    if (!from && !to) return null
    if (!to || from === to) return from
    if (!from) return to
    return `${from} - ${to}`
}


export const renderCourseClassTimetableWithMilestone = ({renderContextMenu = NullAsDefault, displayAll = true} = {}) => (item, index) => {
    const isHappened = parseDayjs(item?.to_date)?.isBefore(dayjs())
    const isMileStone = !!item?.is_milestone

    const renderTime = (time) => {
        const parsed = dayjs(time, "HH:mm:ss")
        return parsed.isValid() ? parsed.format("HH:mm") : null
    }

    const {subject, teacher, notes, from_date, to_date, from_time, to_time, location_address, attendances = [], days_of_week, is_holiday} = item ?? {}

    if (!!!displayAll && isHappened) return null;

    return (
        <Translate key={index}>
            {(t) =>
                renderIfElse(
                    isMileStone,
                    <div className={classNames('flex flex-center gap-3 mt-6 mb-3', isHappened && 'opacity-35')}>
                        <div className="flex-1 max-w-xs border-t border-color-100"/>
                        <div className="flex items-center gap-2 leading-tight flex-shrink-0">
                            <PiArrowFatLineRightFill size={18} className="timeline-icon text-green-300"/>
                            <div className="font-bold text-xl md:text-2xl text-green-700 uppercase italic whitespace-no-wrap">
                                {renderIfElse(
                                    item?.phase_title,
                                    <span>{item?.phase_title}</span>,
                                    <span>{t('phase')}</span>
                                )}
                            </div>
                        </div>
                        <div className="flex-1 max-w-xs border-t border-color-100"/>
                    </div>,
                    <div className={classNames('flex justify-center gap-2 py-3', isHappened && 'opacity-35')}>
                        <div
                            style={{gap: '0.75rem'}}
                            className="create-my-timeline w-full max-w-md flex-row">
                            <div
                                style={{width: 10, marginTop: 4}}
                                className="flex flex-col gap-1 flex-center flex-shrink-0">
                                <GiIronCross
                                    size={9}
                                    style={{
                                        color: isHappened
                                            ? 'var(--text-color-100)'
                                            : 'var(--color-primary-600)',
                                    }}
                                    className="timeline-icon"
                                />
                                <div className="timeline-tail flex-1 h-full"/>
                            </div>
                            <div className="flex flex-col flex-1">
                                {is_holiday === 1 ? (
                                    <div className="flex items-center gap-1">
                                        <PiArrowFatLineRightFill size={11} className="text-primary-300"/>
                                        <span className="font-medium text-sm text-primary-400 italic tracking-widest">
                                            {t('holiday')}
                                        </span>
                                    </div>
                                ) : (
                                    <div className="flex flex-col leading-snug">
                                        {/* HERO: giờ học */}
                                        {renderTime(from_time) && (
                                            <div className="flex items-baseline gap-1.5 tabular-nums">
                                                <span className="font-extrabold text-lg text-blue-600 leading-none">
                                                    {renderTime(from_time)}
                                                </span>
                                                {renderTime(to_time) && (
                                                    <>
                                                        <span className="text-color-300">-</span>
                                                        <span className="font-semibold text-sm text-blue-400 leading-none">
                                                            {renderTime(to_time)}
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        {/* Secondary: môn học */}
                                        {subject && (
                                            <span className="font-bold text-sm md:text-base text-color-000 mt-0.5">
                                                {getTitle(subject)}
                                            </span>
                                        )}
                                        {/* Sublabel: khoảng ngày áp dụng / thứ trong tuần / địa điểm */}
                                        <div className="flex flex-wrap items-center gap-x-1.5 text-xs italic text-color-400 mt-0.5">
                                            <GoDotFill size={8} className="text-color-400"/>
                                            {formatDateRange(from_date, to_date) && (
                                                <span>{formatDateRange(from_date, to_date)}</span>
                                            )}
                                            {days_of_week && (
                                                <>
                                                    <span className="text-color-200">·</span>
                                                    <span>{renderDayOfWeek(days_of_week)}</span>
                                                </>
                                            )}
                                            {location_address && (
                                                <>
                                                    <span className="text-color-200">·</span>
                                                    <span className="text-color-400">{location_address}</span>
                                                </>
                                            )}
                                        </div>
                                        {teacher && (
                                            <div className="flex items-center gap-1 text-xs text-color-400 italic leading-tight mt-0.5">
                                                <GoDotFill size={8}/>
                                                <span>{getTitle(teacher)}</span>
                                            </div>
                                        )}
                                        {notes && (
                                            <div className="flex gap-1 text-xs italic text-color-400 mt-0.5">
                                                <GoDotFill size={8} className="mt-0.5 flex-shrink-0"/>
                                                <span className="font-medium text-color-300 whitespace-pre-line">{notes}</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {renderIf(
                                    attendances.length,
                                    <Popover
                                        title={
                                            <span
                                                className="font-bold text-sm text-color-000">{t('list of lesson')}</span>
                                        }
                                        content={
                                            <div className="flex flex-col gap-1 m-2">
                                                {attendances.map((e, i) => (
                                                    <div key={i} className="flex items-center gap-6 italic">
                                  <span className="font-medium text-sm text-color-100">
                                      {`${i + 1}. ${e.title}`}
                                  </span>
                                                        <span className="font-medium text-xs text-color-100">
                                      <span className="font-normal text-color-400">
                                          {`${t('in attendance')} : `}
                                      </span>
                                                            {`${e.total_attendance}/${e.total_students}`}
                                  </span>
                                                        {renderIf(
                                                            (e.total_excused_absence + e.total_unexcused_absence) > 0,
                                                            <span
                                                                className="font-medium text-xs text-color-100">
                                          <span
                                              className="font-normal text-color-400">{`${t('absence')} : `}</span>
                                                                {e.total_excused_absence + e.total_unexcused_absence}
                                      </span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        }>
                                        <div
                                            className="flex items-center gap-1 font-medium text-xs text-color-400 hover:text-color-100 italic cursor-pointer">
                                            <GoDotFill size={10}/> {t('attendance sheet')}
                                        </div>
                                    </Popover>
                                )}
                            </div>
                        </div>
                        {renderContextMenu(item)}
                    </div>
                )
            }
        </Translate>
    )
}
